import React from "react"
import type { MultipleProductCard, SingularProductCard } from "types"

import { Icon } from "packages/basket-and-checkout/shared/components/Icon/Icon"
import { Button } from "packages/ui-shared/components/Button/Button"
import { iconWrapper } from "./SecondaryProductCardButton.css"

type SecondaryProductCardButtonProps = {
  productCard: MultipleProductCard | SingularProductCard
  handleClick?: (sku: string) => void
}

export const SecondaryProductCardButton = ({
  handleClick,
  productCard,
}: SecondaryProductCardButtonProps) => {
  if (!productCard.secondaryButton) {
    return null
  }

  const { secondaryButton } = productCard
  // TODO: add more button types that require specific icons here
  const icon = secondaryButton.type === "remove" ? "trash-can" : null

  return (
    <Button
      variant="link"
      type="button"
      ariaLabel={productCard.secondaryButton.text}
      handleClick={(event) => {
        event?.preventDefault()
        handleClick?.(productCard.variants[0].sku)
      }}
    >
      {icon ? (
        <span className={iconWrapper}>
          <Icon icon={icon} />
        </span>
      ) : (
        <></>
      )}

      {productCard.secondaryButton.text}
    </Button>
  )
}
